export var StringOperators;
(function (StringOperators) {
    StringOperators["STRING_IN_OPERATOR"] = "IN";
    StringOperators["STRING_NOT_IN_OPERATOR"] = "NOT_IN";
    StringOperators["STRING_CONTAINS_OPERATOR"] = "CONTAINS";
    StringOperators["STRING_NOT_CONTAINS_OPERATOR"] = "NOT_CONTAINS";
    StringOperators["STRING_STARTS_WITH_OPERATOR"] = "STARTS_WITH";
    StringOperators["STRING_NOT_STARTS_WITH_OPERATOR"] = "NOT_STARTS_WITH";
    StringOperators["STRING_ENDS_WITH_OPERATOR"] = "ENDS_WITH";
    StringOperators["STRING_NOT_ENDS_WITH_OPERATOR"] = "NOT_ENDS_WITH";
    StringOperators["STRING_OPERATOR_UNSPECIFIED"] = "UNSPECIFIED";
})(StringOperators || (StringOperators = {}));
